export const SET_TOKEN = 'SET_TOKEN'
export const SET_PUBLIC_KEY = 'SET_PUBLIC_KEY'
export const SET_USER_LOGGED_IN = 'SET_USER_LOGGED_IN'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_PRIMARY_POCKET_DATA = 'SET_PRIMARY_POCKET_DATA'
export const AUTH_RESPONSE = 'AUTH_RESPONSE'
export const RESET_STATE = 'RESET_STATE'
export const SET_LANDING_PAGE_DATA = "SET_LANDING_PAGE_DATA"